import { render, staticRenderFns } from "./AgentToken.vue?vue&type=template&id=5be7c12a&scoped=true"
import script from "./AgentToken.vue?vue&type=script&lang=js"
export * from "./AgentToken.vue?vue&type=script&lang=js"
import style0 from "./AgentToken.vue?vue&type=style&index=0&id=5be7c12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7c12a",
  null
  
)

export default component.exports